import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import React from 'react';
import { styled } from 'styled-components';

export const CloseButtonContainer = styled.div<{
  $top?: string | number;
  $right?: string | number;
}>`
  position: absolute;
  top: ${p => p.$top ?? 0};
  right: ${p => p.$right ?? 0};
`;

interface ModalCloseButtonProps {
  onClick: () => void;
}
export const ModalCloseButton = (props: ModalCloseButtonProps) => {
  const { onClick } = props;

  return (
    <IconButton onClick={onClick}>
      <CloseIcon sx={{ opacity: 0.2 }} />
    </IconButton>
  );
};
